import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "movie-info" }
const _hoisted_4 = { class: "movie-title" }
const _hoisted_5 = {
  key: 1,
  class: "loading"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-ticket fa-fade" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movie_rating = _resolveComponent("movie-rating")!
  const _component_slide = _resolveComponent("slide")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_ctx.movies)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_carousel, { settings: _ctx.carouselSettings }, {
          addons: _withCtx(() => [
            _createVNode(_component_pagination)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movies, (movie) => {
              return (_openBlock(), _createBlock(_component_slide, {
                key: movie.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "carousel__item movie-banner",
                    style: _normalizeStyle({backgroundImage: 'url(' + _ctx.imgUrl(movie.backdrop_path, 'w1280') + ')'}),
                    onClick: ($event: any) => (_ctx.openModal(movie.id))
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(movie.title), 1),
                      _createVNode(_component_movie_rating, {
                        rating: movie.vote_average
                      }, null, 8, ["rating"])
                    ])
                  ], 12, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["settings"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
}